export default "__VITE_ASSET__DambzyK6__"